import React, {FC, Fragment, useMemo} from 'react';

import {Price} from 'components/price/price';
import {BaseItemPrice} from 'desktop/components/baseItemPrice/baseItemPrice';

import {UPGRADE_ALIASES} from '../../constants/upsells';
import {CartItemGlassesTypeV2Type} from '../../types';
import {QuoteItemV2OptionType} from '../../types/quoteItem';
import {BaseInfoRow} from '../baseInfoRowV2/baseInfoRow';

import s from './cartItemUpgrades.scss';

type PropsType = {
    options: CartItemGlassesTypeV2Type['options'];
};

/**
 * Displays only upgrades in one line at one cart item
 * @constructor
 */
export const CartItemUpgrades: FC<PropsType> = ({options}) => {
    const upgrades = useMemo(() => {
        const allOptions: QuoteItemV2OptionType[] = Object.values(options);
        const filteredOptions = allOptions.filter(
            addedOption => addedOption.option && UPGRADE_ALIASES.includes(addedOption.option.alias),
        );

        return filteredOptions.sort((a, b) => a.option.sort - b.option.sort);
    }, [options]);

    if (upgrades.length === 0) return null;

    return (
        <BaseInfoRow
            title={
                <span className={s.upgrades}>
                    {upgrades.map((value, index) => (
                        <Fragment key={value.id}>
                            {value.price === value.finalPrice && value.finalPrice > 0 && (
                                <>
                                    {value.title}&nbsp;(<Price>{value.finalPrice}</Price>)
                                    {index === upgrades.length - 1 ? '' : ', '}
                                </>
                            )}
                            {value.finalPrice > 0 && value.price > value.finalPrice && (
                                <>
                                    {value.title}
                                    <>&nbsp;</>
                                    <span className={s.upgradePrice}>
                                        (
                                        <BaseItemPrice
                                            price={value.price}
                                            specialPrice={value.finalPrice}
                                        />
                                        )<>{index !== upgrades.length - 1 && ', '}&nbsp;</>
                                    </span>
                                </>
                            )}
                        </Fragment>
                    ))}
                </span>
            }
            label="Upgrades:"
        />
    );
};
